<template>
  <div class="row" v-if="can_access('customer','view')">
    <h1 class="">Clients</h1>
    <div class="col-sm-12 p-0" v-if="can_access('customer','modify')">
      <b-button class="btn-info pull-right" @click="showAddCustomerForm=showAddCustomerForm?false:true" title="Add Customer"><i :class="showAddCustomerForm?'fa fa-minus':'fa fa-plus'"></i></b-button>
    </div>
    <div v-if="showAddCustomerForm && can_access('customer','modify')">
      <AddCustomerForm :forceRerender="customerFormReRender"/>
    </div>
    <div class="col-sm-12 p-0 mb-2" v-if="can_access('customer','modify')">
      <select name="type" class="form-control col-sm-2 pull-right" v-model="status">
        <option selected value="1">active</option>
        <option value="0">inactive</option>
      </select>
    </div>
    <TableView :col="columns" :getData="getData" v-if="showAddCustomerList && can_access('customer','view')"/>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import AddCustomerForm from '@/components/Accounts/AddCustomerForm';
import TableView from '@/components/Common/DataTable/Table';

export default {
  name: 'CustomersPage',
  components: { Widget, AddCustomerForm, TableView },
  mixins: [common],
  data() {
    return {
      showAddCustomerForm: false,
      showAddCustomerList: true,
      errorMessage: null,
      status: 1,
      columns: (() => {
        const cols = [
          { title: 'Approve', tdComp: 'customerApprove', visible: this.can_access('customer_approve','view') },
          { title: 'Accoun No.', field: 'account_number', label: 'User ID', thComp: 'FilterTh', sortable: true, visible: 'true' },
          { title: 'Title', field: 'title', thComp: 'FilterTh' },
          { title: 'Firstname', field: 'firstname', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' } },
          { title: 'Lastname', field: 'lastname', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' } },
          { title: 'Email', field: 'email', thComp: 'FilterTh', tdComp: 'Email'},
          { title: 'Phone', field: 'phone_no', thComp: 'FilterTh'},
          { title: 'DOB/Incorporation Date', field: 'dob', sortable: true },
          { title: 'Create time', field: 'created_at', sortable: true, colClass: 'w-240' },
          { title: 'Operation', tdComp: 'Opt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch: {
    status: function(value){
      this.showAddCustomerList = false;
      this.$nextTick(function(){
        this.showAddCustomerList = true;
      });
    }
  },
  methods: {
    customerFormReRender(response) {
      if(response.code==0){
        this.showAddCustomerForm = false;
        this.showAddCustomerList = false;
        this.$nextTick(function(){
          this.showAddCustomerForm = true;
          this.showAddCustomerList = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query, filter) {
      const { limit = 100, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));

      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      if(this.status==0) uri += '&inactive=1'; 
      return await this.call_axios(uri);
    }
  },
  created() {
    
  },
};
</script>